import React, { useEffect } from "react";
import { withRouter, Switch, Route, Redirect } from "react-router";
import { connect } from "react-redux";
import {
  KISKLogin,
  Login,
  DashBoard,
  Navigation,
  EnterPage,
  Nav,
  Settingnav,
} from "./loadable";
import "./App.css";
const mapStateToProps = (state) => {
  let { errortype } = state;
  return {
    errortype,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(({ errortype }) => {
    useEffect(() => {
      document.title = "CCKM";
      // 获取window的宽高
      let { orientation } = window;
      let root = document.getElementById("root");
      if (orientation == "0" || orientation == "180") {
        let { clientHeight } = document.documentElement;
        root.style.height = "56.25vw";
        document.body.style.marginTop = `calc(${
          clientHeight / 2
        }px - 28.125vw)`;
      } else {
        root.style.height = "100%";
      }
    }, []);
    return (
      <Switch>
        <Redirect exact from="/" to="/nav" />
        <Route path="/nav" component={Nav} />
        <Route path="/login" component={Login} />
        <Route path="/dashboard" component={DashBoard} />
        <Route path="/navigation" component={Navigation} />
        <Route path="/settingnav" component={Settingnav} />
      </Switch>
    );
  })
);
